import { render, staticRenderFns } from "./NbStatus.vue?vue&type=template&id=0951476b&scoped=true&"
import script from "./NbStatus.vue?vue&type=script&lang=js&"
export * from "./NbStatus.vue?vue&type=script&lang=js&"
import style0 from "./NbStatus.vue?vue&type=style&index=0&id=0951476b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0951476b",
  null
  
)

export default component.exports